import React from 'react'
import { withRouter } from 'react-router-dom'

import data from '../../../../data/carriers'

import SVGLayer from './SVGLayer'
import Description from './Description'
import LayerContent from '../../LayerContent'

const Carriers = () => {
  return (
    <LayerContent>
      {({ active, setActiveProject }) => (
        <SVGLayer
          data={data}
          active={active}
          setActiveProject={setActiveProject}
        />
      )}
    </LayerContent>
  )
}

export { Description as CarrierDescription }
export default withRouter(Carriers)
